import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/brokerage.css";

/**
 * Confirmation screen shown after broker registration completes, routing
 * the broker to login or straight to the dashboard depending on whether
 * they signed up via Google.
 */
const SuccessScreen = ({ brokerName, brokerId, fromGoogle, onReset }) => {
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setVisible(true), 50);
        return () => clearTimeout(t);
    }, []);

    return (
        <div className={`broker-success${visible ? " broker-success--visible" : ""}`}>
            <div className="broker-success__circle">
                <svg viewBox="0 0 80 80" className="broker-success__svg">
                    <circle cx="40" cy="40" r="38" className="broker-success__ring" />
                    <polyline
                        points="22,42 34,54 58,28"
                        className="broker-success__check"
                    />
                </svg>
            </div>

            <h2 className="broker-success__title">Registration Successful!</h2>

            <p className="broker-success__message">
                Welcome to the platform, <strong>{brokerName}</strong>!<br />
                Our team will review your profile and get in touch shortly.
            </p>

            {brokerId && (
                <div className="broker-success__id-box">
                    <span className="broker-success__id-label">Your Broker ID</span>
                    <span className="broker-success__id-value">{brokerId}</span>
                    <button
                        className="broker-success__copy-btn"
                        onClick={() => navigator.clipboard?.writeText(brokerId)}
                        title="Copy to clipboard"
                    >
                        📋
                    </button>
                </div>
            )}

            <div className="broker-success__steps">
                <div className="broker-success__step">
                    <span className="broker-success__step-icon">📧</span>
                    <p>We've emailed you a welcome note with your Broker ID</p>
                </div>
                <div className="broker-success__step">
                    <span className="broker-success__step-icon">📞</span>
                    <p>Our team reviews your account, usually within 24 hours</p>
                </div>
                <div className="broker-success__step">
                    <span className="broker-success__step-icon">🏠</span>
                    <p>Once approved, add listings and projects from your dashboard</p>
                </div>
            </div>

            {fromGoogle ? (
                <button
                    className="broker-success__reset-btn"
                    onClick={() => navigate("/broker/dashboard")}
                    style={{marginBottom: 10}}
                >
                    Go to Dashboard
                </button>
            ) : (
                <button
                    className="broker-success__reset-btn"
                    onClick={() => navigate("/broker/login")}
                    style={{marginBottom: 10}}
                >
                    Login to Your Dashboard
                </button>
            )}

            <button className="broker-success__reset-btn" onClick={onReset}>
                Register Another Broker
            </button>
        </div>
    );
};

export default SuccessScreen;
